module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }